import './textarea.component.scss';

import { memo } from 'react';

const Textarea = ({
  style,
  className,
  name,
  value,
  placeholder,
  isInvalid,
  disabled,
  onChange,
  onClick,
  onFocus,
  onBlur
}) => {
  const invalidClassName = !!isInvalid ? 'invalid' : '';

  return (
    <div className='textarea-container'>
      <textarea
        className={`${className} ${invalidClassName}`}
        {...{ style }}
        {...{ name }}
        {...{ value }}
        {...{ placeholder }}
        {...{ disabled }}
        {...{ onChange }}
        {...{ onClick }}
        {...{ onFocus }}
        {...{ onBlur }}
      />
    </div>
  );
};

export default memo(Textarea);
